import { createSlice } from "@reduxjs/toolkit";
import POD from "../../ts/models/POD";

type InitialState = {
  pod: POD;
  resourceName: string;
};

const emptyPod = { ...new POD() };

const initialState: InitialState = {
  pod: emptyPod,
  resourceName: localStorage.getItem("resourceName") || "cimpar",
};

const pod = createSlice({
  name: "pod",
  initialState,
  reducers: {
    getPOD: (state, action) => {
      state.pod = action.payload;
    },
    setResourceName: (state, action) => {
      state.resourceName = action.payload;
    },
  },
});

export const podActions = pod.actions;

export default pod.reducer;
